module.exports = __webpack_public_path__ + "media/images/eyecatch-submittion-sm-203d4240372d4b543b95f78aa9ae2d65.svg";